import { isAfter, parseISO } from "date-fns";

import useCountdownToDate from "features/common/hooks/useCountdownToDate";

import TimerBlock, { Dimensions, TimeUnits } from "./components/TimerBlock";
import TimerLayout from "./components/TimerLayout";

type Props = {
  endTime: string;
  showUnusedUnitsUpTo?: Extract<TimeUnits, TimeUnits.DAYS | TimeUnits.HOURS>;
  hideSeconds?: boolean;
  simple?: boolean;
  dimensions?: Dimensions;
};

export default function Timer({
  endTime,
  showUnusedUnitsUpTo,
  hideSeconds,
  simple = false,
  dimensions
}: Props) {
  const { days, hours, minutes, seconds } = useCountdownToDate({
    endTime
  });

  const now = new Date();

  const timeOut = endTime ? isAfter(now, parseISO(endTime)) : false;

  const showDays = days !== "00" || showUnusedUnitsUpTo === TimeUnits.DAYS;

  const showHours =
    showDays || hours !== "00" || showUnusedUnitsUpTo === TimeUnits.HOURS;

  return (
    <TimerLayout simple={simple} dividerSize={dimensions?.dividerSize}>
      {showDays && (
        <TimerBlock
          timeUnit={TimeUnits.DAYS}
          timeValue={timeOut ? "00" : days}
          simple={simple}
          dimensions={dimensions}
        />
      )}
      {showHours && (
        <TimerBlock
          timeUnit={TimeUnits.HOURS}
          timeValue={timeOut ? "00" : hours}
          simple={simple}
          dimensions={dimensions}
        />
      )}
      <TimerBlock
        timeUnit={TimeUnits.MINUTES}
        timeValue={timeOut ? "00" : minutes}
        simple={simple}
        dimensions={dimensions}
      />
      {!hideSeconds && (
        <TimerBlock
          timeUnit={TimeUnits.SECONDS}
          timeValue={timeOut ? "00" : seconds}
          simple={simple}
          dimensions={dimensions}
        />
      )}
    </TimerLayout>
  );
}
